(function () {
  document.addEventListener("theme:cart:add", async () => {
    await fetch("/cart/clear.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
    });
  });
})();
